import React from 'react'
import MaterialSymbol from '../material-symbol'

const PhotoCamera = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="photo_camera" {...props} />
))

PhotoCamera.displayName = 'PhotoCamera'

export default PhotoCamera
